export default "__VITE_ASSET__uyY0D8VZ__"